import { z } from 'zod'

export const Scope = z
  .object({
    uuid: z.string().default(''),
    name: z.string().default(''),
    accessLevel: z.string().default(''),
    type: z.string().optional()
  })
  .default({})
export type Scope = z.infer<typeof Scope>

export interface ScopeRequest {
  uuid?: string
  name?: string
  type?: string
  accessLevel?: string
  organisations?: string[]
  users?: string[]
}
